module.exports = __webpack_public_path__ + "static/img/2-4.2eb7eef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature/face/2-4.png
// module id = 2J3o
// module chunks = 1